// Mock data for Gearbox Reparation Website

// Service details mapping
export const serviceDetailsMap = {
  1: { data: 'gearboxTypes', secondaryData: 'repairMethods' }, // Gearbox Repair
  2: { data: 'maintenanceTypes' }, // General Maintenance
  3: { data: 'diagnosticDetails' }, // Diagnostics
  4: { data: 'brakingDetails' }, // Braking
  5: { data: 'airConditioningDetails' }, // Air Conditioning
  6: { data: 'geometryDetails' }, // Geometry & Alignment
  7: { data: 'bodyworkDetails' }, // Bodywork
  8: { data: 'inspectionDetails' }, // Pre-MOT Inspection
  9: { data: 'rimsDetails' } // Wheels & Rims
};

export const services = [
  {
    id: 1,
    title: "Gearbox Repair",
    description: "Complete diagnostic and repair services for all types of automatic transmissions. Our expert technicians identify and fix issues efficiently.",
    icon: "wrench",
    image: "https://static.vecteezy.com/system/resources/thumbnails/004/044/802/small/side-view-cross-section-of-automatic-transmission-gearbox-photo.jpg"
  },
  {
    id: 2,
    title: "General Maintenance",
    description: "Complete vehicle maintenance: oil changes, filters, brake pads, timing belts, and regular inspections to keep your vehicle in perfect condition.",
    icon: "settings",
    image: "https://images.unsplash.com/photo-1771340742493-52fbd5476ccb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxjYXIlMjBvaWwlMjBjaGFuZ2UlMjBtYWludGVuYW5jZSUyMG1lY2hhbmljfGVufDB8fHx8MTc3NDg3MTE4MXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "Diagnostics",
    description: "Advanced electronic diagnostics to identify all vehicle problems. Complete analysis with professional equipment for all brands.",
    icon: "search",
    image: "https://images.pexels.com/photos/12271951/pexels-photo-12271951.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 4,
    title: "Braking",
    description: "Complete brake service: pads, discs, calipers, brake fluid. Safety and performance for reliable braking.",
    icon: "disc",
    image: "https://images.unsplash.com/photo-1656232976683-7b688560e427?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxicmFrZSUyMGRpc2MlMjBwYWRzJTIwY2FyJTIwcmVwYWlyfGVufDB8fHx8MTc3NDg3MTE4Mnww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 5,
    title: "Air Conditioning",
    description: "Air conditioning service and repair, refrigerant recharge, leak detection. Optimal comfort all year round.",
    icon: "wind",
    image: "https://images.unsplash.com/photo-1587121892719-1711ec9cc798?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxjYXIlMjBhaXIlMjBjb25kaXRpb25pbmclMjBzeXN0ZW0lMjByZXBhaXJ8ZW58MHx8fHwxNzc0ODcxMTgzfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 6,
    title: "Geometry & Alignment",
    description: "Precise wheel alignment and geometry adjustment. Improved handling and reduced tire wear.",
    icon: "target",
    image: "https://images.unsplash.com/photo-1683614986827-d5670c9d0e06?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHx3aGVlbCUyMGFsaWdubWVudCUyMGdlb21ldHJ5JTIwY2FyJTIwc2VydmljZXxlbnwwfHx8fDE3NzQ4NzExODR8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 7,
    title: "Bodywork",
    description: "Bodywork repair, painting, dent removal. Restore your vehicle's appearance.",
    icon: "car",
    image: "https://images.pexels.com/photos/6870314/pexels-photo-6870314.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 8,
    title: "Pre-MOT Inspection",
    description: "Complete pre-technical inspection to prepare your vehicle. Identify and resolve issues before the official test.",
    icon: "clipboard-check",
    image: "https://images.unsplash.com/photo-1632733711679-529326f6db12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxjYXIlMjBpbnNwZWN0aW9uJTIwbWVjaGFuaWMlMjBjaGVja2xpc3R8ZW58MHx8fHwxNzc0ODcxMTg3fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 9,
    title: "Wheels & Rims",
    description: "Wheel repair, replacement, and replica rims. Restore the look and performance of your wheels.",
    icon: "circle",
    image: "https://images.pexels.com/photos/4002394/pexels-photo-4002394.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  }
];

export const maintenanceTypes = [
  {
    id: 1,
    type: "Vidange Moteur",
    typeEn: "Oil Change",
    icon: "droplet",
    description: "Remplacement de l'huile moteur et du filtre. Essentiel pour la longévité du moteur.",
    descriptionEn: "Engine oil and filter replacement. Essential for engine longevity.",
    interval: "Tous les 10,000-15,000 km",
    intervalEn: "Every 10,000-15,000 km",
    includes: ["Vidange huile moteur", "Remplacement filtre à huile", "Contrôle niveau liquides", "Réinitialisation compteur"],
    includesEn: ["Engine oil drain", "Oil filter replacement", "Fluid level check", "Service counter reset"]
  },
  {
    id: 2,
    type: "Entretien Freinage",
    typeEn: "Brake Maintenance",
    icon: "disc",
    description: "Vérification et entretien complet du système de freinage pour votre sécurité.",
    descriptionEn: "Complete brake system inspection and maintenance for your safety.",
    interval: "Tous les 30,000 km",
    intervalEn: "Every 30,000 km",
    includes: ["Contrôle plaquettes", "Vérification disques", "Test liquide de frein", "Inspection étriers"],
    includesEn: ["Brake pad inspection", "Disc check", "Brake fluid test", "Caliper inspection"]
  },
  {
    id: 3,
    type: "Courroie de Distribution",
    typeEn: "Timing Belt",
    icon: "refresh-cw",
    description: "Remplacement de la courroie de distribution, élément vital du moteur.",
    descriptionEn: "Timing belt replacement, a vital engine component.",
    interval: "Tous les 80,000-120,000 km",
    intervalEn: "Every 80,000-120,000 km",
    includes: ["Remplacement courroie", "Contrôle tendeurs", "Vérification pompe à eau", "Réglage calage distribution"],
    includesEn: ["Belt replacement", "Tensioner check", "Water pump inspection", "Timing adjustment"]
  },
  {
    id: 4,
    type: "Filtres & Bougies",
    typeEn: "Filters & Spark Plugs",
    icon: "filter",
    description: "Remplacement des filtres (air, habitacle, carburant) et bougies d'allumage.",
    descriptionEn: "Replacement of filters (air, cabin, fuel) and spark plugs.",
    interval: "Tous les 20,000-40,000 km",
    intervalEn: "Every 20,000-40,000 km",
    includes: ["Filtre à air", "Filtre habitacle", "Filtre à carburant", "Bougies d'allumage"],
    includesEn: ["Air filter", "Cabin filter", "Fuel filter", "Spark plugs"]
  },
  {
    id: 5,
    type: "Révision Complète",
    typeEn: "Full Service",
    icon: "clipboard-check",
    description: "Révision complète selon préconisations constructeur avec contrôle multipoints.",
    descriptionEn: "Complete service according to manufacturer specifications with multi-point inspection.",
    interval: "Annuel ou 15,000 km",
    intervalEn: "Annual or 15,000 km",
    includes: ["Vidange complète", "Tous les filtres", "Contrôle 50 points", "Rapport détaillé"],
    includesEn: ["Full oil change", "All filters", "50-point check", "Detailed report"]
  },
  {
    id: 6,
    type: "Climatisation",
    typeEn: "Air Conditioning",
    icon: "wind",
    description: "Entretien du système de climatisation, recharge gaz, désinfection.",
    descriptionEn: "Air conditioning system maintenance, gas recharge, disinfection.",
    interval: "Tous les 2 ans",
    intervalEn: "Every 2 years",
    includes: ["Recharge gaz réfrigérant", "Désinfection circuit", "Contrôle étanchéité", "Test performance"],
    includesEn: ["Refrigerant recharge", "Circuit disinfection", "Leak test", "Performance test"]
  }
];

export const diagnosticDetails = [
  {
    id: 1,
    title: "Diagnostic Électronique",
    titleEn: "Electronic Diagnostics",
    description: "Lecture et analyse des codes défauts via valise OBD2 professionnelle.",
    descriptionEn: "Reading and analysis of fault codes via professional OBD2 scanner.",
    image: "https://images.pexels.com/photos/12271951/pexels-photo-12271951.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 2,
    title: "Diagnostic Mécanique",
    titleEn: "Mechanical Diagnostics",
    description: "Inspection visuelle et tests des composants mécaniques du véhicule.",
    descriptionEn: "Visual inspection and testing of vehicle mechanical components.",
    image: "https://images.unsplash.com/photo-1632733711679-529326f6db12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxjYXIlMjBpbnNwZWN0aW9uJTIwbWVjaGFuaWMlMjBjaGVja2xpc3R8ZW58MHx8fHwxNzc0ODcxMTg3fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "Test Routier",
    titleEn: "Road Test",
    description: "Essai sur route pour identifier les anomalies de comportement.",
    descriptionEn: "Road test to identify behavior anomalies.",
    image: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0NTA1fDB8MXxzZWFyY2h8Mnx8ZHJpdmluZyUyMGNhcnxlbnwwfHx8fDE3NzQ4NzM0Njh8MA&ixlib=rb-4.1.0&q=85"
  }
];

export const brakingDetails = [
  {
    id: 1,
    title: "Plaquettes de Frein",
    titleEn: "Brake Pads",
    description: "Remplacement des plaquettes avant et arrière pour un freinage optimal.",
    descriptionEn: "Front and rear brake pad replacement for optimal braking.",
    image: "https://images.unsplash.com/photo-1656232976683-7b688560e427?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxicmFrZSUyMGRpc2MlMjBwYWRzJTIwY2FyJTIwcmVwYWlyfGVufDB8fHx8MTc3NDg3MTE4Mnww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Disques de Frein",
    titleEn: "Brake Discs",
    description: "Remplacement ou rectification des disques usés ou voilés.",
    descriptionEn: "Replacement or resurfacing of worn or warped discs.",
    image: "https://images.pexels.com/photos/13243/pexels-photo-13243.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 3,
    title: "Liquide de Frein",
    titleEn: "Brake Fluid",
    description: "Purge et remplacement du liquide de frein pour une sécurité maximale.",
    descriptionEn: "Brake fluid flush and replacement for maximum safety.",
    image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0NTA1fDB8MXxzZWFyY2h8M3x8YnJha2UlMjBmbHVpZHxlbnwwfHx8fDE3NzQ4NzM0OTB8MA&ixlib=rb-4.1.0&q=85"
  }
];

export const airConditioningDetails = [
  {
    id: 1,
    title: "Recharge Climatisation",
    titleEn: "AC Recharge",
    description: "Recharge du gaz réfrigérant pour un refroidissement efficace.",
    descriptionEn: "Refrigerant gas recharge for efficient cooling.",
    image: "https://images.unsplash.com/photo-1587121892719-1711ec9cc798?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxjYXIlMjBhaXIlMjBjb25kaXRpb25pbmclMjBzeXN0ZW0lMjByZXBhaXJ8ZW58MHx8fHwxNzc0ODcxMTgzfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Désinfection Circuit",
    titleEn: "Circuit Disinfection",
    description: "Nettoyage antibactérien du circuit pour éliminer les odeurs.",
    descriptionEn: "Antibacterial circuit cleaning to eliminate odors.",
    image: "https://images.pexels.com/photos/3806249/pexels-photo-3806249.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 3,
    title: "Réparation Fuites",
    titleEn: "Leak Repair",
    description: "Détection et réparation des fuites du système de climatisation.",
    descriptionEn: "Detection and repair of air conditioning system leaks.",
    image: "https://images.unsplash.com/photo-1621905252507-b35492cc74b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0NTA1fDB8MXxzZWFyY2h8Mnx8Y2FyJTIwcmVwYWlyfGVufDB8fHx8MTc3NDg3MzU0M3ww&ixlib=rb-4.1.0&q=85"
  }
];

export const geometryDetails = [
  {
    id: 1,
    title: "Parallélisme",
    titleEn: "Wheel Alignment",
    description: "Réglage précis du parallélisme pour une usure uniforme des pneus.",
    descriptionEn: "Precise alignment adjustment for even tire wear.",
    image: "https://images.unsplash.com/photo-1683614986827-d5670c9d0e06?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHx3aGVlbCUyMGFsaWdubWVudCUyMGdlb21ldHJ5JTIwY2FyJTIwc2VydmljZXxlbnwwfHx8fDE3NzQ4NzExODR8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Équilibrage Roues",
    titleEn: "Wheel Balancing",
    description: "Équilibrage des roues pour éliminer les vibrations.",
    descriptionEn: "Wheel balancing to eliminate vibrations.",
    image: "https://images.pexels.com/photos/4002394/pexels-photo-4002394.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 3,
    title: "Contrôle Géométrie",
    titleEn: "Geometry Check",
    description: "Contrôle complet de la géométrie sur banc spécialisé.",
    descriptionEn: "Complete geometry check on specialized bench.",
    image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0NTA1fDB8MXxzZWFyY2h8M3x8Y2FyJTIwd2hlZWx8ZW58MHx8fHwxNzc0ODczNTgyfDA&ixlib=rb-4.1.0&q=85"
  }
];

export const bodyworkDetails = [
  {
    id: 1,
    title: "Débosselage Sans Peinture",
    titleEn: "Paintless Dent Removal",
    icon: "target",
    description: "Technique moderne permettant de réparer les petites bosses et impacts sans endommager la peinture d'origine. Idéal pour les dommages causés par la grêle, les portes de parking ou les chocs légers.",
    descriptionEn: "Modern technique for repairing small dents and impacts without damaging the original paint. Ideal for hail damage, parking door dings, or light impacts.",
    advantages: ["Conservation peinture d'origine", "Réparation rapide (1-2h)", "Coût réduit", "Pas de temps de séchage"],
    advantagesEn: ["Original paint preservation", "Fast repair (1-2h)", "Reduced cost", "No drying time"],
    image: "https://images.pexels.com/photos/6870314/pexels-photo-6870314.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 2,
    title: "Peinture Carrosserie",
    titleEn: "Bodywork Painting",
    icon: "droplet",
    description: "Application professionnelle de peinture en cabine spécialisée. Utilisation de peintures de qualité constructeur avec correspondance exacte de la teinte d'origine.",
    descriptionEn: "Professional paint application in specialized booth. Use of manufacturer-quality paints with exact original color matching.",
    advantages: ["Teinte garantie exacte", "Cabine à température contrôlée", "Protection UV incluse", "Finition brillante durable"],
    advantagesEn: ["Guaranteed exact color match", "Temperature-controlled booth", "UV protection included", "Durable glossy finish"],
    image: "https://images.pexels.com/photos/3807386/pexels-photo-3807386.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 3,
    title: "Rénovation & Polissage",
    titleEn: "Renovation & Polishing",
    icon: "refresh-cw",
    description: "Traitement complet pour redonner l'éclat d'origine à votre carrosserie. Élimination des micro-rayures, oxydation et ternissement par polissage mécanique professionnel.",
    descriptionEn: "Complete treatment to restore your bodywork's original shine. Removal of micro-scratches, oxidation and dullness through professional mechanical polishing.",
    advantages: ["Suppression rayures légères", "Restauration brillance", "Protection longue durée", "Effet neuf garanti"],
    advantagesEn: ["Light scratch removal", "Shine restoration", "Long-lasting protection", "Like-new finish guaranteed"],
    image: "https://images.unsplash.com/photo-1607860108855-64acf2078ed9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0NTA1fDB8MXxzZWFyY2h8Mnx8Y2FyJTIwcG9saXNofGVufDB8fHx8MTc3NDg3MzYyOHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    title: "Réparation Pare-chocs",
    titleEn: "Bumper Repair",
    icon: "shield",
    description: "Réparation et remise en état des pare-chocs plastiques endommagés. Soudure plastique, comblement et peinture pour un résultat invisible.",
    descriptionEn: "Repair and restoration of damaged plastic bumpers. Plastic welding, filling and painting for an invisible result.",
    advantages: ["Évite le remplacement coûteux", "Réparation solide et durable", "Repeint à l'identique", "Délai rapide"],
    advantagesEn: ["Avoids costly replacement", "Strong and durable repair", "Exact color repaint", "Quick turnaround"],
    image: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0NTA1fDB8MXxzZWFyY2h8NHx8Y2FyJTIwYnVtcGVyJTIwcmVwYWlyfGVufDB8fHx8MTc3NDg3Mzc0OXww&ixlib=rb-4.1.0&q=85"
  }
];

export const inspectionDetails = [
  {
    id: 1,
    title: "Contrôle Visuel",
    titleEn: "Visual Inspection",
    description: "Inspection complète de tous les éléments visibles du véhicule.",
    descriptionEn: "Complete inspection of all visible vehicle elements.",
    image: "https://images.unsplash.com/photo-1632733711679-529326f6db12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxjYXIlMjBpbnNwZWN0aW9uJTIwbWVjaGFuaWMlMjBjaGVja2xpc3R8ZW58MHx8fHwxNzc0ODcxMTg3fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Test Freinage",
    titleEn: "Brake Test",
    description: "Test sur banc de freinage pour vérifier l'efficacité.",
    descriptionEn: "Brake bench test to verify effectiveness.",
    image: "https://images.unsplash.com/photo-1656232976683-7b688560e427?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxicmFrZSUyMGRpc2MlMjBwYWRzJTIwY2FyJTIwcmVwYWlyfGVufDB8fHx8MTc3NDg3MTE4Mnww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "Contrôle Pollution",
    titleEn: "Emissions Test",
    description: "Mesure des émissions polluantes et opacité des fumées.",
    descriptionEn: "Pollutant emissions and smoke opacity measurement.",
    image: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0NTA1fDB8MXxzZWFyY2h8M3x8Y2FyJTIwZXhoYXVzdHxlbnwwfHx8fDE3NzQ4NzM2ODN8MA&ixlib=rb-4.1.0&q=85"
  }
];

export const rimsDetails = [
  {
    id: 1,
    title: "Réparation Jantes",
    titleEn: "Rim Repair",
    description: "Réparation des rayures, éclats et déformations sur jantes alliage.",
    descriptionEn: "Repair of scratches, chips and deformations on alloy rims.",
    image: "https://images.pexels.com/photos/4002394/pexels-photo-4002394.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 2,
    title: "Remplacement Jantes",
    titleEn: "Rim Replacement",
    description: "Fourniture et pose de jantes neuves d'origine ou équivalentes.",
    descriptionEn: "Supply and installation of new original or equivalent rims.",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0NTA1fDB8MXxzZWFyY2h8Mnx8Y2FyJTIwd2hlZWx8ZW58MHx8fHwxNzc0ODczNzIyfDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "Répliques",
    titleEn: "Replicas",
    description: "Jantes répliques de qualité au design identique pour tous budgets.",
    descriptionEn: "Quality replica rims with identical design for all budgets.",
    image: "https://images.pexels.com/photos/36556346/pexels-photo-36556346.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  }
];

export const gearboxTypes = [
  {
    id: 1,
    type: "Convertisseur de Couple",
    typeEn: "Torque Converter",
    icon: "circle-dot",
    description: "Système hydraulique traditionnel offrant douceur et confort. Utilise un fluide pour transmettre la puissance du moteur aux roues.",
    descriptionEn: "Traditional hydraulic system offering smoothness and comfort. Uses fluid to transmit engine power to the wheels.",
    advantages: ["Conduite souple et confortable", "Fiabilité éprouvée", "Adapté à tous types de conduite"],
    advantagesEn: ["Smooth and comfortable driving", "Proven reliability", "Suitable for all driving styles"],
    commonIssues: ["Usure du fluide de transmission", "Surchauffe en conduite intensive", "Glissement du convertisseur"],
    commonIssuesEn: ["Transmission fluid wear", "Overheating in intensive driving", "Converter slipping"],
    image: "https://static.vecteezy.com/system/resources/thumbnails/004/044/802/small/side-view-cross-section-of-automatic-transmission-gearbox-photo.jpg"
  },
  {
    id: 2,
    type: "Boîte à Double Embrayage (DCT)",
    typeEn: "Dual-Clutch Transmission (DCT)",
    icon: "layers",
    description: "Deux embrayages indépendants pour des changements de vitesse ultra-rapides. Combinaison de performance et d'efficacité.",
    descriptionEn: "Two independent clutches for ultra-fast gear changes. Combination of performance and efficiency.",
    advantages: ["Changements de vitesse très rapides", "Consommation réduite", "Performance sportive"],
    advantagesEn: ["Very fast gear changes", "Reduced consumption", "Sporty performance"],
    commonIssues: ["Usure des embrayages", "À-coups à basse vitesse", "Problèmes de mécatronique"],
    commonIssuesEn: ["Clutch wear", "Jerking at low speed", "Mechatronic issues"],
    image: "https://static.vecteezy.com/system/resources/thumbnails/054/876/862/small/cross-section-of-modern-car-automatic-transmission-gearbox-showing-gears-and-clutch-disks-isolated-on-white-background-photo.jpg"
  },
  {
    id: 3,
    type: "Transmission CVT",
    typeEn: "CVT Transmission",
    icon: "activity",
    description: "Variation continue sans rapport fixe. Optimise la consommation et offre une accélération linéaire.",
    descriptionEn: "Continuous variation without fixed ratio. Optimizes consumption and offers linear acceleration.",
    advantages: ["Excellente économie de carburant", "Accélération fluide", "Simplicité mécanique"],
    advantagesEn: ["Excellent fuel economy", "Smooth acceleration", "Mechanical simplicity"],
    commonIssues: ["Usure de la courroie/chaîne", "Bruits caractéristiques", "Sensations de conduite différentes"],
    commonIssuesEn: ["Belt/chain wear", "Characteristic noises", "Different driving feel"],
    image: "https://static.vecteezy.com/system/resources/thumbnails/030/823/880/small/car-transmission-gearbox-with-visible-gears-and-cogs-vehicle-photo.jpg"
  },
  {
    id: 4,
    type: "Boîte Robotisée",
    typeEn: "Automated Manual",
    icon: "cpu",
    description: "Boîte manuelle avec embrayage automatisé. Solution économique pour l'automatisation.",
    descriptionEn: "Manual gearbox with automated clutch. Economical solution for automation.",
    advantages: ["Coût réduit", "Consommation optimisée", "Entretien simplifié"],
    advantagesEn: ["Reduced cost", "Optimized consumption", "Simplified maintenance"],
    commonIssues: ["Temps de changement de vitesse", "À-coups possibles", "Usure de l'embrayage"],
    commonIssuesEn: ["Gear change time", "Possible jerking", "Clutch wear"],
    image: "https://static.vecteezy.com/system/resources/thumbnails/036/389/804/small/car-transmission-cutaway-3d-rendering-on-white-background-photo.jpg"
  }
];

export const repairMethods = [
  {
    id: 1,
    method: "Diagnostic Électronique",
    methodEn: "Electronic Diagnostics",
    icon: "search",
    description: "Analyse complète des codes d'erreur et paramètres de fonctionnement via outils de diagnostic professionnels.",
    descriptionEn: "Complete analysis of error codes and operating parameters using professional diagnostic tools.",
    steps: ["Connexion au système embarqué", "Lecture des codes défauts", "Analyse des données en temps réel", "Identification précise du problème"],
    stepsEn: ["Connection to onboard system", "Reading fault codes", "Real-time data analysis", "Precise problem identification"]
  },
  {
    id: 2,
    method: "Vidange et Entretien",
    methodEn: "Fluid Change & Maintenance",
    icon: "droplet",
    description: "Remplacement du fluide de transmission, nettoyage et remplacement des filtres pour maintenir les performances optimales.",
    descriptionEn: "Transmission fluid replacement, cleaning and filter replacement to maintain optimal performance.",
    steps: ["Drainage complet du fluide usagé", "Nettoyage du carter", "Remplacement des filtres", "Remplissage avec fluide spécifique"],
    stepsEn: ["Complete drainage of used fluid", "Sump cleaning", "Filter replacement", "Filling with specific fluid"]
  },
  {
    id: 3,
    method: "Réparation Mécanique",
    methodEn: "Mechanical Repair",
    icon: "wrench",
    description: "Intervention sur les composants internes : embrayages, engrenages, convertisseurs selon les besoins.",
    descriptionEn: "Work on internal components: clutches, gears, converters as needed.",
    steps: ["Dépose de la boîte", "Démontage et inspection", "Remplacement des pièces usées", "Remontage et calibrage"],
    stepsEn: ["Gearbox removal", "Disassembly and inspection", "Replacement of worn parts", "Reassembly and calibration"]
  },
  {
    id: 4,
    method: "Reprogrammation",
    methodEn: "Reprogramming",
    icon: "terminal",
    description: "Mise à jour ou adaptation du logiciel de gestion de la transmission pour optimiser les performances.",
    descriptionEn: "Update or adaptation of transmission management software to optimize performance.",
    steps: ["Sauvegarde des paramètres actuels", "Analyse du comportement", "Modification des cartographies", "Tests et validation"],
    stepsEn: ["Backup of current parameters", "Behavior analysis", "Map modification", "Testing and validation"]
  }
];

export const features = [
  {
    id: 1,
    title: "Expert Technicians",
    description: "Our certified mechanics have over 20 years of combined experience in automatic transmission repair.",
    icon: "award"
  },
  {
    id: 2,
    title: "Quality Parts",
    description: "We use only OEM and premium aftermarket parts to ensure lasting repairs.",
    icon: "shield-check"
  },
  {
    id: 3,
    title: "Fast Service",
    description: "Most repairs completed within 24-48 hours to get you back on the road quickly.",
    icon: "clock"
  },
  {
    id: 4,
    title: "Warranty Included",
    description: "All our work comes with a comprehensive warranty for your peace of mind.",
    icon: "file-check"
  }
];

export const contactInfo = {
  phone: "01 60 04 31 23",
  email: "esblyauto@gmail.com",
  address: "2 rue Louis Braille, 77450 Esbly, France",
  hours: "Lun-Jeu: 8h30-12h / 13h30-18h30, Ven: 8h30-12h / 13h30-17h30"
};

// Mock function to simulate form submission
export const submitContactForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Contact form submitted:", formData);
      resolve({ success: true, message: "Thank you for contacting us! We'll get back to you soon." });
    }, 1000);
  });
};
